<template>
  <div>
    <AppDataProperty
      contentId="subscription"
      @dataAvailable="
        data => {
          subscription = data?.metaData || {}
        }
      "
    />
    <div
      class="glassBg w-full grid grid-cols-5 p-4 py-12 pt-14"
      style="clip-path: polygon(100% 5%, 0% 20%, 0% 100%, 100% 100%)"
    >
      <div
        class="absolute bottom-0 w-full h-5 z-[-1]"
        style="background: linear-gradient(to top, #242c3b 20%, #0000)"
      ></div>
      <div
        class="flex flex-col items-center"
        v-for="(tab, i) in tabs.slice(0, 2)"
        :key="i"
        @click="selectTab(tab)"
        :class="{
          'opacity-50': selectedTab.id !== tab.id,
        }"
        :id="'home_navigation_' + tab.id"
      >
        <div class="w-8 h-8">
          <img :src="tab.icon" alt="" class="w-full h-full" />
        </div>
        <div class="text-sm -mb-2">
          {{ tab.name }}
        </div>
      </div>
      <div
        class="flex items-center justify-center"
        @click="selectTab(tabs[2])"
        :id="'home_navigation_' + tabs[2].id"
      >
        <div class="absolute">
          <div
            :class="{
              '!opacity-10 !w-16 !h-16': selectedTab.id !== tabs[2].id,
            }"
            class="opacity-60 w-20 h-20 rounded-[10px] rotate-45 duration-300"
            style="
              background: linear-gradient(
                149.07deg,
                #34c8e8 9.45%,
                #4e4af2 136.18%
              );
              box-shadow: 0px 20px 30px rgba(16, 20, 28, 0.6);
            "
          >
            <div class="gradient-border border-sm !opacity-40"></div>
          </div>
        </div>
        <div class="absolute">
          <div
            class="w-14 h-14 rounded-[10px] rotate-45"
            style="
              background: linear-gradient(
                149.07deg,
                #34c8e8 9.45%,
                #4e4af2 136.18%
              );
            "
          ></div>
        </div>
        <div class="absolute">
          <img
            src="@/assets/images/king-recharge-assets/logo-white.svg"
            alt=""
            class="w-10 h-10"
          />
        </div>
      </div>
      <div
        class="flex flex-col items-center"
        v-for="(tab, i) in tabs.slice(3)"
        @click="selectTab(tab)"
        :id="'home_navigation_' + tab.id"
        :key="i"
      >
        <div
          class="flex flex-col items-center relative"
          :key="i"
          :id="'home_navigation_' + tab.id"
        >
          <div
            class="w-8 h-8"
            :class="{
              'opacity-50': selectedTab.id !== tab.id,
            }"
          >
            <img :src="tab.icon" alt="" class="w-full h-full" />
          </div>
          <div
            class="text-sm -mb-2"
            :class="{
              'opacity-50': selectedTab.id !== tab.id,
            }"
          >
            {{ tab.name }}
          </div>
          <div
            class="absolute -right-3 translate-x-1/2 -top-0"
            v-if="subscription.isActive && tab.id == 'profile'"
          >
            <div class="px-2 rounded-lg text-sm bg-[#ff5c74f0] text-white">
              VIP
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import AppDataProperty from '@/components/appData/AppDataProperty.vue'
import HelpButtons from '@/components/appComponent/HelpButtons.vue'

import homeIcon from '@/assets/images/all/home-white.svg'
import couponsIcon from '@/assets/images/all/discount-voucher-white.svg'
import transactionsIcon from '@/assets/images/all/order-history-white.svg'
import profileIcon from '@/assets/images/king-recharge-assets/person-white.svg'

export default defineComponent({
  name: 'HomeBottomNavs',
  components: { AppDataProperty, HelpButtons },
  props: {},
  data() {
    return {
      tabs: [
        {
          name: 'Accueil',
          icon: homeIcon,
          id: 'home',
        },
        {
          name: 'Coupons',
          icon: couponsIcon,
          id: 'coupons',
        },
        {
          name: 'MainHome',
          icon: '',
          id: 'mainHome',
        },
        {
          name: 'Historique',
          icon: transactionsIcon,
          id: 'transactions',
        },
        {
          name: 'Profile',
          icon: profileIcon,
          id: 'profile',
        },
      ],
      selectedTab: {
        id: 'mainHome',
      },
      eventsIds: [],
      initiated: true,
      subscription: {},
    }
  },
  beforeUnmount() {
    this.eventsIds.map(this.$Events.removeHandler)
  },
  mounted() {
    // this.selectTab(this.tabs[2]);
    const id = this.$Events.handleEvent(
      'home_tab_activated',
      this.onTabActivated,
    )
    this.eventsIds.push(id)
    setTimeout(() => {
      this.initiated = true
    }, 1000)
  },
  methods: {
    selectTab(tab) {
      if (!this.initiated) return
      this.selectedTab = tab
    },
    onTabActivated(tab) {
      const matchingTab = this.tabs.find(internTab => internTab.id == tab?.id)
      if (!matchingTab) return
      if (this.selectedTab.id == matchingTab.id) return
      this.selectTab(matchingTab)
    },
  },
  watch: {
    selectedTab(newTab) {
      this.$Events.dispatchEvent('home_tabs_navigation', {
        id: newTab.id,
      })
    },
  },
})
</script>
